import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from './images/total.png'
import _imports_1 from './images/loading.png'


const _hoisted_1 = { class: "business" }
const _hoisted_2 = { class: "btns" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = {
  class: "fonts",
  style: {"position":"absolute","top":"0"}
}
const _hoisted_5 = { class: "total" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "totalTitle" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "总销售量")
], -1)
const _hoisted_8 = { class: "bottom" }
const _hoisted_9 = { class: "con" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "平方米", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "328",
  height: "240"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  width: "459",
  height: "34"
}, null, -1)
const _hoisted_13 = { class: "con" }
const _hoisted_14 = ["src"]

export function render(_ctx, _cache) {
  const _component_MiniTitle = _resolveComponent("MiniTitle")
  const _component_RotateAnimation = _resolveComponent("RotateAnimation")
  const _component_Aura = _resolveComponent("Aura")
  const _component_item = _resolveComponent("item")

  return (_openBlock(), _createBlock(_component_item, { title: "陆港业务量" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_MiniTitle, { title: "关于总量" }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createElementVNode("span", {
                class: _normalizeClass({active: _ctx.type === '总收益'}),
                onClick: _cache[0] || (_cache[0] = $event => (_ctx.type='总收益'))
              }, "总收益", 2)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("span", {
                class: _normalizeClass({active: _ctx.type === '总收入'}),
                onClick: _cache[1] || (_cache[1] = $event => (_ctx.type='总收入'))
              }, "总收入", 2)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_RotateAnimation, {
            data: _ctx.trafficList[_ctx.type],
            type: _ctx.type
          }, null, 8, ["data", "type"]),
          _createVNode(_component_Aura),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h3", null, [
                (_ctx.trafficList[_ctx.type])
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.trafficList[_ctx.type].totalCount), 1))
                  : _createCommentVNode("", true),
                _createTextVNode(_toDisplayString(_ctx.type === '总收益' ? '万箱' : '万元'), 1)
              ])
            ]),
            _hoisted_7
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createVNode(_component_MiniTitle, { title: "仓储面积" }),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("h3", null, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.introdutionInfo.onlineCount), 1),
                  _hoisted_10
                ]),
                _hoisted_11,
                _hoisted_12
              ])
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_MiniTitle, { title: "入驻客户" }),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("img", {
                  src: _ctx.introdutionInfo.customInfo,
                  width: "519",
                  height: "268"
                }, null, 8, _hoisted_14)
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}